import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IAddressInfo, ITraderInfo } from "../interface/ITrader";
import { RootState } from "../store/store";

import { logoutUser } from "./common";
import TraderService from "../service/TraderService";
import { GetTraderStatusParamModel } from "../model/common";

export const resetTrader = createAction("trader/reset");
const _service = new TraderService();
type SliceState = { value: ITraderInfo | null; status: string };

export const getTraderLiveStatusAsync = createAsyncThunk(
  "trader/getTraderLiveStatus",
  async (params: GetTraderStatusParamModel) => {
    const response = await _service.getTraderStatusService(params);
    return response;
  }
);



const initialState = {
  value: null,
  status: COMMON_STATUS.INITIAL,
} as SliceState;

export const traderSlice = createSlice({
  name: "trader",
  initialState,
  reducers: {
    setCurrentTrader: (state, action) => {
      state.value = action.payload;
      state.status = COMMON_STATUS.LOADED;
    },
    updateTraderLive: (state, action) => {
      if (state && state.value)
        state.value.live = action.payload;
    },
    updateTraderAddresses: (state: SliceState, action) => {
      if (state && state.value) {
        state.value?.addresses.map((m: IAddressInfo) => {
          const found = action.payload.find((aId: number) => m.id === aId);
          m.live = found > 0;
        });

      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTraderLiveStatusAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getTraderLiveStatusAsync.fulfilled, (state: SliceState, action) => {
        if (state && state.value) {
          state.value.live = action.payload.traderLive;
          state.value?.addresses.map((m: IAddressInfo) => {
            const found = action.payload.liveAddresses.find((aId: number) => m.id === aId);
            m.live = found > 0;
          });
        }
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getTraderLiveStatusAsync.rejected, (state: SliceState,) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetTrader, (n) => {
        return initialState;
      });
  },
});

export const { setCurrentTrader, updateTraderLive ,updateTraderAddresses} = traderSlice.actions;
export const getCurrentTrader = (state: RootState) => state.trader.value;
export const hasCurrentTrader = (state: RootState) =>
  state.trader.value != null;
export const getTradersStatus = (state: RootState) => state.trader.status;
export const getCurrentTraderAddresses = (state: RootState) =>
  state.trader.value ? state.trader.value?.addresses : [];
export const getCurrentTraderId = (state: RootState) =>
  state.trader.value ? state.trader.value.id : null;
export default traderSlice.reducer;
